const LINKS = [
  {
    title: "Home",
    path: "/",
  },
  {
    title: "About us",
    path: "/about-us",
  },
  {
    title: "Villas",
    path: "/villas",
  },
  {
    title: "Around us",
    path: "/around-us",
  },
];

export default LINKS;
